webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(113);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(1369);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueMaterial = __webpack_require__(1373);
	
	var _vueMaterial2 = _interopRequireDefault(_vueMaterial);
	
	var _vueCodemirror = __webpack_require__(1367);
	
	var _vueCodemirror2 = _interopRequireDefault(_vueCodemirror);
	
	__webpack_require__(354);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueMaterial2.default);
	_vue2.default.use(_vueCodemirror2.default);
	
	_vue2.default.material.registerTheme({
	  default: {
	    primary: 'indigo',
	    accent: 'pink'
	  }
	});
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },

/***/ 114:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(116);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _clipboard = __webpack_require__(126);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	var _jsonSchemaFaker = __webpack_require__(1318);
	
	var _jsonSchemaFaker2 = _interopRequireDefault(_jsonSchemaFaker);
	
	var _jsonSchemaGenerator = __webpack_require__(1339);
	
	var _jsonSchemaGenerator2 = _interopRequireDefault(_jsonSchemaGenerator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	
	  data: function data() {
	    return {
	      json_editor_options: {
	        tabSize: 2,
	        mode: 'application/json',
	        lineNumbers: true,
	        line: true,
	        keyMap: 'sublime'
	      },
	      scheme_editor_options: {
	        tabSize: 2,
	        lineNumbers: true,
	        mode: 'application/json',
	        line: true,
	        keyMap: 'sublime'
	      },
	      json: '',
	      schema: '',
	      message: ''
	    };
	  },
	
	
	  computed: {
	    error: function error() {
	      try {
	        JSON.parse(this.json);
	
	        return false;
	      } catch (e) {
	        return true;
	      }
	    }
	  },
	
	  created: function created() {
	    var json = [{
	      address: {
	        streetAddress: '21 2nd Street',
	        city: 'New York'
	      },
	      phoneNumber: [{
	        location: 'home',
	        code: 44
	      }]
	    }, {
	      address: {
	        streetAddress: '22 2nd Street',
	        city: 'New York'
	      },
	      phoneNumber: [{
	        location: 'office',
	        code: 45
	      }]
	    }];
	
	    this.json = (0, _stringify2.default)(json, null, 2);
	  },
	  mounted: function mounted() {
	    this.generateSchema();
	
	    new _clipboard2.default('.md-copy-button');
	  },
	
	
	  methods: {
	    generateSchema: function generateSchema() {
	      if (this.error) {
	        return this.openSnackbar('Please fix your JSON first!');
	      }
	
	      this.schema = (0, _stringify2.default)((0, _jsonSchemaGenerator2.default)(JSON.parse(this.json)), null, 2);
	    },
	    generateJSON: function generateJSON() {
	      this.json = (0, _stringify2.default)((0, _jsonSchemaFaker2.default)(JSON.parse(this.schema)), null, 2);
	    },
	    copySchema: function copySchema() {
	      this.openSnackbar('Schema copied to clipboard.');
	    },
	    copyJSON: function copyJSON() {
	      this.openSnackbar('JSON copied to clipboard.');
	    },
	    openSnackbar: function openSnackbar(message) {
	      this.message = message;
	
	      this.$refs.snackbar.open();
	    }
	  }
	};

/***/ },

/***/ 115:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(119);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CodeMirror = __webpack_require__(2);
	var CodeMirrorMetas = __webpack_require__(1368);
	__webpack_require__(303);
	__webpack_require__(300);
	__webpack_require__(128);
	exports.default = {
	  data: function data() {
	    return {
	      content: ''
	    };
	  },
	  props: {
	    hint: Boolean,
	    code: String,
	    value: String,
	    unseenLines: Array,
	    marker: Function,
	    options: {
	      type: Object,
	      default: function _default() {
	        return {
	          styleActiveLine: true,
	          lineNumbers: true,
	          mode: 'text/javascript',
	          lineWrapping: true
	        };
	      }
	    }
	  },
	  created: function created() {
	    this.options = this.options || {};
	    var language = this.options.mode || 'text/javascript';
	    var theme = this.options.theme;
	    var hint = this.hint || false;
	    var hints = ['css', 'html', 'javascript', 'sql', 'xml'];
	
	    if (typeof language == 'string') {
	
	      var lang = CodeMirrorMetas.findModeByMIME(language);
	      language = !lang ? lang : lang.mode;
	    } else if ((typeof language === 'undefined' ? 'undefined' : (0, _typeof3.default)(language)) == 'object') {
	
	      var _lang = CodeMirrorMetas.findModeByName(language.name);
	      if (_lang) {
	        language = _lang.mode;
	      } else {
	        return console.error('CodeMirror language mode: ' + language.name + ' configuration error (CodeMirror语言模式配置错误，或者不支持此语言) See http://codemirror.net/mode/ for more details.');
	      }
	    }
	
	    if (hint) {
	      __webpack_require__(74);
	      __webpack_require__(302);
	      var isAnyword = hints.indexOf(language) == -1;
	      __webpack_require__(136)("./" + (isAnyword ? 'anyword' : language) + '-hint.js');
	    }
	
	    if (this.options.styleActiveLine) __webpack_require__(144);
	
	    if (this.options.autoCloseBrackets) __webpack_require__(129);
	
	    if (this.options.autoCloseTags) __webpack_require__(130);
	
	    if (this.options.styleSelectedText) {
	      __webpack_require__(145);
	      __webpack_require__(8);
	    }
	
	    if (this.options.highlightSelectionMatches) {
	      __webpack_require__(76);
	      __webpack_require__(77);
	      __webpack_require__(8);
	      __webpack_require__(142);
	    }
	
	    if (!!this.options.keyMap && ['emacs', 'sublime', 'vim'].indexOf(this.options.keyMap) > -1) {
	      __webpack_require__(26);
	      __webpack_require__(44);
	      __webpack_require__(127);
	      __webpack_require__(43);
	      __webpack_require__(299);
	      __webpack_require__(8);
	      __webpack_require__(143);
	
	      __webpack_require__(146)("./" + this.options.keyMap + '.js');
	    }
	
	    if (this.options.foldGutter) {
	      __webpack_require__(301);
	      __webpack_require__(131);
	      __webpack_require__(132);
	      __webpack_require__(72);
	      __webpack_require__(133);
	      __webpack_require__(134);
	      __webpack_require__(135);
	      __webpack_require__(73);
	    }
	
	    language = language || 'javascript';
	    if (language !== 'null') __webpack_require__(150)("./" + language + '/' + language + '.js');
	
	    if (!!theme && theme == 'solarized light') theme = 'solarized';
	    if (!!theme && theme != 'default') __webpack_require__(254)("./" + theme + '.css');
	  },
	  ready: function ready() {
	    var _this = this;
	    this.editor = CodeMirror.fromTextArea(this.$el, this.options);
	    this.editor.setValue(this.code || this.value || this.content);
	    this.editor.on('change', function (cm) {
	      _this.content = cm.getValue();
	
	      _this.code = cm.getValue();
	    });
	  },
	  mounted: function mounted() {
	    var _this = this;
	    this.editor = CodeMirror.fromTextArea(this.$el, this.options);
	    this.editor.setValue(this.code || this.value || this.content);
	    this.editor.on('change', function (cm) {
	      _this.content = cm.getValue();
	      if (!!_this.$emit) {
	        _this.$emit('changed', _this.content);
	        _this.$emit('input', _this.content);
	      }
	    });
	    this.unseenLineMarkers();
	  },
	  watch: {
	    'code': function code(newVal, oldVal) {
	      var editor_value = this.editor.getValue();
	      if (newVal !== editor_value) {
	        var scrollInfo = this.editor.getScrollInfo();
	        this.editor.setValue(newVal);
	        this.content = newVal;
	        this.editor.scrollTo(scrollInfo.left, scrollInfo.top);
	      }
	      this.unseenLineMarkers();
	    },
	    'value': function value(newVal, oldVal) {
	      var editor_value = this.editor.getValue();
	      if (newVal !== editor_value) {
	        var scrollInfo = this.editor.getScrollInfo();
	        this.editor.setValue(newVal);
	        this.content = newVal;
	        this.editor.scrollTo(scrollInfo.left, scrollInfo.top);
	      }
	      this.unseenLineMarkers();
	    }
	  },
	  methods: {
	    unseenLineMarkers: function unseenLineMarkers() {
	      var _this = this;
	      if (_this.unseenLines !== undefined && _this.marker !== undefined) {
	        _this.unseenLines.forEach(function (line) {
	          var info = _this.editor.lineInfo(line);
	          _this.editor.setGutterMarker(line, "breakpoints", info.gutterMarkers ? null : _this.marker());
	        });
	      }
	    }
	  }
	};

/***/ },

/***/ 136:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./anyword-hint.js": 137,
		"./css-hint.js": 138,
		"./html-hint.js": 139,
		"./javascript-hint.js": 140,
		"./show-hint.js": 74,
		"./sql-hint.js": 141,
		"./xml-hint.js": 75
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 136;


/***/ },

/***/ 146:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./emacs.js": 147,
		"./sublime.js": 148,
		"./vim.js": 149
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 146;


/***/ },

/***/ 150:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./apl/apl.js": 151,
		"./asciiarmor/asciiarmor.js": 152,
		"./asn.1/asn.1.js": 153,
		"./asterisk/asterisk.js": 154,
		"./brainfuck/brainfuck.js": 155,
		"./clike/clike.js": 26,
		"./clojure/clojure.js": 156,
		"./cmake/cmake.js": 157,
		"./cobol/cobol.js": 158,
		"./coffeescript/coffeescript.js": 78,
		"./commonlisp/commonlisp.js": 159,
		"./crystal/crystal.js": 160,
		"./css/css.js": 21,
		"./cypher/cypher.js": 161,
		"./d/d.js": 162,
		"./dart/dart.js": 163,
		"./diff/diff.js": 164,
		"./django/django.js": 165,
		"./dockerfile/dockerfile.js": 166,
		"./dtd/dtd.js": 167,
		"./dylan/dylan.js": 168,
		"./ebnf/ebnf.js": 169,
		"./ecl/ecl.js": 170,
		"./eiffel/eiffel.js": 171,
		"./elm/elm.js": 172,
		"./erlang/erlang.js": 173,
		"./factor/factor.js": 174,
		"./fcl/fcl.js": 175,
		"./forth/forth.js": 176,
		"./fortran/fortran.js": 177,
		"./gas/gas.js": 178,
		"./gfm/gfm.js": 179,
		"./gherkin/gherkin.js": 180,
		"./go/go.js": 181,
		"./groovy/groovy.js": 182,
		"./haml/haml.js": 183,
		"./handlebars/handlebars.js": 79,
		"./haskell-literate/haskell-literate.js": 184,
		"./haskell/haskell.js": 80,
		"./haxe/haxe.js": 185,
		"./htmlembedded/htmlembedded.js": 186,
		"./htmlmixed/htmlmixed.js": 5,
		"./http/http.js": 187,
		"./idl/idl.js": 188,
		"./javascript/javascript.js": 12,
		"./jinja2/jinja2.js": 189,
		"./jsx/jsx.js": 190,
		"./julia/julia.js": 191,
		"./livescript/livescript.js": 192,
		"./lua/lua.js": 193,
		"./markdown/markdown.js": 81,
		"./mathematica/mathematica.js": 194,
		"./mbox/mbox.js": 195,
		"./meta.js": 82,
		"./mirc/mirc.js": 196,
		"./mllike/mllike.js": 197,
		"./modelica/modelica.js": 198,
		"./mscgen/mscgen.js": 199,
		"./mumps/mumps.js": 200,
		"./nginx/nginx.js": 201,
		"./nsis/nsis.js": 202,
		"./ntriples/ntriples.js": 203,
		"./octave/octave.js": 204,
		"./oz/oz.js": 205,
		"./pascal/pascal.js": 206,
		"./pegjs/pegjs.js": 207,
		"./perl/perl.js": 208,
		"./php/php.js": 209,
		"./pig/pig.js": 210,
		"./powershell/powershell.js": 211,
		"./properties/properties.js": 212,
		"./protobuf/protobuf.js": 213,
		"./pug/pug.js": 83,
		"./puppet/puppet.js": 214,
		"./python/python.js": 84,
		"./q/q.js": 215,
		"./r/r.js": 216,
		"./rpm/rpm.js": 217,
		"./rst/rst.js": 218,
		"./ruby/ruby.js": 46,
		"./rust/rust.js": 219,
		"./sas/sas.js": 220,
		"./sass/sass.js": 85,
		"./scheme/scheme.js": 221,
		"./shell/shell.js": 222,
		"./sieve/sieve.js": 223,
		"./slim/slim.js": 224,
		"./smalltalk/smalltalk.js": 225,
		"./smarty/smarty.js": 226,
		"./solr/solr.js": 227,
		"./soy/soy.js": 228,
		"./sparql/sparql.js": 229,
		"./spreadsheet/spreadsheet.js": 230,
		"./sql/sql.js": 86,
		"./stex/stex.js": 87,
		"./stylus/stylus.js": 88,
		"./swift/swift.js": 231,
		"./tcl/tcl.js": 232,
		"./textile/textile.js": 233,
		"./tiddlywiki/tiddlywiki.js": 234,
		"./tiki/tiki.js": 235,
		"./toml/toml.js": 236,
		"./tornado/tornado.js": 237,
		"./troff/troff.js": 238,
		"./ttcn-cfg/ttcn-cfg.js": 239,
		"./ttcn/ttcn.js": 240,
		"./turtle/turtle.js": 241,
		"./twig/twig.js": 242,
		"./vb/vb.js": 243,
		"./vbscript/vbscript.js": 244,
		"./velocity/velocity.js": 245,
		"./verilog/verilog.js": 246,
		"./vhdl/vhdl.js": 247,
		"./vue/vue.js": 248,
		"./webidl/webidl.js": 249,
		"./xml/xml.js": 22,
		"./xquery/xquery.js": 250,
		"./yacas/yacas.js": 251,
		"./yaml-frontmatter/yaml-frontmatter.js": 252,
		"./yaml/yaml.js": 89,
		"./z80/z80.js": 253
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 150;


/***/ },

/***/ 254:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./3024-day.css": 304,
		"./3024-night.css": 305,
		"./abcdef.css": 306,
		"./ambiance-mobile.css": 307,
		"./ambiance.css": 308,
		"./base16-dark.css": 309,
		"./base16-light.css": 310,
		"./bespin.css": 311,
		"./blackboard.css": 312,
		"./cobalt.css": 313,
		"./colorforth.css": 314,
		"./dracula.css": 315,
		"./duotone-dark.css": 316,
		"./duotone-light.css": 317,
		"./eclipse.css": 318,
		"./elegant.css": 319,
		"./erlang-dark.css": 320,
		"./hopscotch.css": 321,
		"./icecoder.css": 322,
		"./isotope.css": 323,
		"./lesser-dark.css": 324,
		"./liquibyte.css": 325,
		"./material.css": 326,
		"./mbo.css": 327,
		"./mdn-like.css": 328,
		"./midnight.css": 329,
		"./monokai.css": 330,
		"./neat.css": 331,
		"./neo.css": 332,
		"./night.css": 333,
		"./panda-syntax.css": 334,
		"./paraiso-dark.css": 335,
		"./paraiso-light.css": 336,
		"./pastel-on-dark.css": 337,
		"./railscasts.css": 338,
		"./rubyblue.css": 339,
		"./seti.css": 340,
		"./solarized.css": 341,
		"./the-matrix.css": 342,
		"./tomorrow-night-bright.css": 343,
		"./tomorrow-night-eighties.css": 344,
		"./ttcn.css": 345,
		"./twilight.css": 346,
		"./vibrant-ink.css": 347,
		"./xq-dark.css": 348,
		"./xq-light.css": 349,
		"./yeti.css": 350,
		"./zenburn.css": 351
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 254;


/***/ },

/***/ 299:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 300:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 301:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 302:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 303:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 304:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 305:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 306:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 307:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 308:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 309:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 310:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 311:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 312:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 313:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 314:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 315:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 316:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 317:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 318:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 319:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 320:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 321:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 322:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 323:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 324:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 325:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 326:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 327:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 328:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 329:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 330:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 331:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 332:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 333:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 334:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 335:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 336:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 337:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 338:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 339:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 340:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 341:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 342:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 343:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 344:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 345:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 346:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 347:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 348:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 349:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 350:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 351:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 352:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 353:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 354:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 1369:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(352)
	
	var Component = __webpack_require__(112)(
	  /* name */
	  "App",
	  /* script */
	  __webpack_require__(114),
	  /* template */
	  __webpack_require__(1371),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 1370:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(353)
	
	var Component = __webpack_require__(112)(
	  /* name */
	  "codemirror",
	  /* script */
	  __webpack_require__(115),
	  /* template */
	  __webpack_require__(1372),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 1371:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('md-snackbar', {
	    ref: "snackbar",
	    attrs: {
	      "md-position": "bottom center",
	      "md-duration": "25000"
	    }
	  }, [_c('span', {
	    domProps: {
	      "textContent": _vm._s(_vm.message)
	    }
	  }), _vm._v(" "), _c('md-button', {
	    staticClass: "md-accent",
	    attrs: {
	      "md-theme": "default"
	    },
	    on: {
	      "click": function($event) {
	        _vm.$refs.snackbar.close()
	      }
	    }
	  }, [_vm._v("Got it")])], 1), _vm._v(" "), _c('md-toolbar', [_c('h2', {
	    staticClass: "md-title",
	    staticStyle: {
	      "flex": "1"
	    }
	  }, [_vm._v("Schema Generator")]), _vm._v(" "), _c('a', {
	    staticClass: "md-button md-icon-button",
	    attrs: {
	      "target": "_blank",
	      "href": "https://github.com/flipboxstudio/schema-generator"
	    }
	  }, [_c('md-icon', [_vm._v("favorite")])], 1)]), _vm._v(" "), _c('md-layout', {
	    attrs: {
	      "md-gutter": "",
	      "id": "app-container"
	    }
	  }, [_c('md-layout', {
	    attrs: {
	      "md-flex": "50"
	    }
	  }, [_c('div', {
	    staticClass: "fluid"
	  }, [_c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("JSON")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("Put your JSON here")])]), _vm._v(" "), _c('md-card-content', [_c('codemirror', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.json),
	      expression: "json"
	    }],
	    staticClass: "fluid",
	    attrs: {
	      "options": _vm.json_editor_options
	    },
	    domProps: {
	      "value": (_vm.json)
	    },
	    on: {
	      "input": function($event) {
	        _vm.json = $event
	      }
	    }
	  }), _vm._v(" "), (_vm.error) ? _c('span', {
	    staticClass: "help-block warn"
	  }, [_vm._v("Holly crap! You provide invalid JSON.")]) : _c('span', {
	    staticClass: "help-block success"
	  }, [_vm._v("Great! Your JSON is valid.")])], 1), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
	    staticClass: "md-raised md-copy-button",
	    attrs: {
	      "data-clipboard-text": _vm.json
	    },
	    on: {
	      "click": _vm.copyJSON
	    }
	  }, [_vm._v("Copy JSON")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised md-primary",
	    on: {
	      "click": _vm.generateSchema
	    }
	  }, [_vm._v("Generate Schema")])], 1)], 1)], 1)]), _vm._v(" "), _c('md-layout', {
	    attrs: {
	      "md-flex": "50"
	    }
	  }, [_c('div', {
	    staticClass: "fluid"
	  }, [_c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Schema")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("Your schema will generated here")])]), _vm._v(" "), _c('md-card-content', [_c('codemirror', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.schema),
	      expression: "schema"
	    }],
	    staticClass: "fluid",
	    attrs: {
	      "options": _vm.scheme_editor_options
	    },
	    domProps: {
	      "value": (_vm.schema)
	    },
	    on: {
	      "input": function($event) {
	        _vm.schema = $event
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "help-block"
	  }, [_vm._v("Read more about JSON schema "), _c('a', {
	    attrs: {
	      "href": "http://json-schema.org/"
	    }
	  }, [_vm._v("here")]), _vm._v(".")])], 1), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
	    staticClass: "md-raised",
	    on: {
	      "click": _vm.generateJSON
	    }
	  }, [_vm._v("Generate JSON")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised md-primary md-copy-button",
	    attrs: {
	      "data-clipboard-text": _vm.schema
	    },
	    on: {
	      "click": _vm.copySchema
	    }
	  }, [_vm._v("Copy schema")])], 1)], 1)], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ },

/***/ 1372:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('textarea')
	},staticRenderFns: []}

/***/ },

/***/ 1374:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ 1375:
/***/ function(module, exports) {

	/* (ignored) */

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.f56828fe15752df9f133.js